import React from 'react';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import s from './JournalTags.scss';
export var JournalTags = function (_a) {
    var tags = _a.tags;
    return tags ? (React.createElement("div", { className: s['tags'] },
        React.createElement(FoldableTagList, { tags: tags }))) : null;
};
JournalTags.displayName = 'JournalTags';
export default JournalTags;
//# sourceMappingURL=JournalTags.js.map